<script lang="ts">
	import Button from '$lib/components/util/Button.svelte';
	import Input from '$lib/components/inputs/Input.svelte';
	import { page } from '$app/stores';
	import Text from '$lib/components/Text.svelte';
	import { showLocationOptions } from '$lib/stores/shopStore';
	import { getText } from '$lib/util/translations';
	import Loader from './Loader.svelte';

	let loading: boolean = false;

	async function registerNewsletter() {
		success = false;
		error = false;
		loading = true;

		const res = await fetch('/api/newsletter-klaviyo', {
			method: 'POST',
			body: JSON.stringify({
				firstname,
				lastname,
				email
			})
		});

		let data = await res.json();
		data = JSON.parse(data.data);
		data = JSON.parse(data[0]);

		if (data.success) {
			success = true;
			email = '';
			firstname = '';
			lastname = '';
		} else {
			error = true;
			if (data.error) {
				errorMsg = data.error;
			}
		}
		loading = false;
	}

	let success: boolean = false;
	let error: boolean = false;
	let errorMsg: string;
	let email: string = '';
	let firstname: string = '';
	let lastname: string = '';
</script>

<div class="subscription-wrapper">
	<div class="container">
		<div class="subscription-title">
			<Text key="footer_subscription_title" />
		</div>
		<div class="subscription-text">
			<Text key="footer_subscription_text" />
		</div>
		<div class="input-wrapper">
			<Input
				id="firstname"
				label=""
				name="firstname"
				type="text"
				bind:value={firstname}
				placeholder={getText($page.data.globalTexts, 'ecom_firstname').text}
			/>
			<Input
				id="lastname"
				label=""
				name="lastname"
				type="text"
				bind:value={lastname}
				placeholder={getText($page.data.globalTexts, 'ecom_lastname').text}
			/>
			<Input
				id="email"
				label=""
				name="email"
				type="email"
				bind:value={email}
				placeholder={getText($page.data.globalTexts, 'ecom_email').text}
			/>
		</div>
		<Button
			textKey="footer_subscribe_now"
			style="yellow"
			variant="full"
			on:click={registerNewsletter}
		>
			<span slot="custom_before" class="loader-wrapper">
				{#if loading}
					<span style="margin-inline-start: 8px">
						<Loader size={16} width={3} color="black" />
					</span>
				{/if}
			</span>
		</Button>
		<div class="message">
			{#if success}<Text key="newsletter_success" />{/if}
			{#if error}<Text key={errorMsg ? 'error_' + errorMsg : 'newsletter_error'} />{/if}
		</div>
		<div class="agreement">
			<Text key="footer_subscription_agreement" />
		</div>
	</div>
</div>

<style lang="scss">
	.subscription-wrapper {
		color: color(yellow);
		display: flex;
		flex-direction: column;
		justify-content: center;
		position: relative;
		border-image-source: url(../../assets/img/footer-border.svg);
		border-image-width: 4px;
		border-image-slice: 2 4 fill;
		border-image-outset: 20px;
		border-image-repeat: strech;
		@media (max-width: 1200px) {
			width: 280px;
			border-image-outset: 0px;
		}
	}
	.container {
		padding: v(content-padding-sm);
		height: 100%;
		@media (max-width: 1200px) {
			padding: v(content-padding);
			// max-width: 50%;
		}
		:global(button) {
			width: 100%;
			justify-content: center;
			gap: 0 !important;
			:global(.text) {
				text-align: center;
				width: 100%;
			}
		}
	}

	.subscription-title {
		@include font(h5);
		margin-bottom: v(content-gap-sm);
	}
	.subscription-text {
		@include font(text-sm);
		margin-bottom: v(content-gap);
	}
	.agreement {
		@include font(text-xs);
		margin-top: v(content-gap);
	}
	.input-wrapper {
		:global(input) {
			background: transparent;
			border: solid 1px color(yellow);
			border-radius: v(border-radius);
			margin-bottom: v(content-padding-sm);
			color: color(yellow);
			@include media(phone) {
				font-size: 16px;
			}
		}
		:global(input::placeholder) {
			color: color(yellow);
		}
	}
	.loader-wrapper {
		height: 16px;
		margin: 0 !important;

		:global(.loader-wrapper) {
			margin-top: 0;
		}
	}
</style>
